import {
  CONSOLE_ROUTES,
  type ConsoleSkill,
  type ConsoleSkillDetail,
  ConsoleSkillDetailSchema,
  type ConsoleSkillFile,
  ConsoleSkillSchema,
  ConsoleSkillsSchema,
  type ConsoleSkillUpdateRequest,
  type TenantId,
} from '@plato/shared';
import { callConsoleApi, sendToConsoleApi } from './http-client.ts';

export interface SkillsConsoleData {
  listSkills(tenant: TenantId): Promise<readonly ConsoleSkill[]>;
  getSkill(tenant: TenantId, skillId: string): Promise<ConsoleSkillDetail>;
  addSkill(tenant: TenantId, files: readonly ConsoleSkillFile[]): Promise<ConsoleSkill>;
  addSkillVersion(
    tenant: TenantId,
    skillId: string,
    files: readonly ConsoleSkillFile[],
  ): Promise<ConsoleSkill>;
  updateSkill(
    tenant: TenantId,
    skillId: string,
    change: ConsoleSkillUpdateRequest,
  ): Promise<ConsoleSkill>;
  deleteSkill(tenant: TenantId, skillId: string): Promise<void>;
}

export const httpSkillsData: SkillsConsoleData = {
  listSkills: async (tenant) =>
    (await callConsoleApi(CONSOLE_ROUTES.skills(tenant), ConsoleSkillsSchema)).skills,
  getSkill: (tenant, skillId) =>
    callConsoleApi(CONSOLE_ROUTES.skill(tenant, skillId), ConsoleSkillDetailSchema),
  addSkill: (tenant, files) =>
    callConsoleApi(CONSOLE_ROUTES.skills(tenant), ConsoleSkillSchema, {
      method: 'POST',
      body: { files },
    }),
  addSkillVersion: (tenant, skillId, files) =>
    callConsoleApi(CONSOLE_ROUTES.skillVersions(tenant, skillId), ConsoleSkillSchema, {
      method: 'POST',
      body: { files },
    }),
  updateSkill: (tenant, skillId, change) =>
    callConsoleApi(CONSOLE_ROUTES.skill(tenant, skillId), ConsoleSkillSchema, {
      method: 'PATCH',
      body: change,
    }),
  deleteSkill: (tenant, skillId) =>
    sendToConsoleApi(CONSOLE_ROUTES.skill(tenant, skillId), { method: 'DELETE' }),
};
